<template>
    <div class="i-detail-view">
        <div class="view-area"
             v-for="(item1,index1) in getAttrs"
             :key="index1">
            <div class="view-head"
                 v-if="item1.head"
                 v-text="item1.head.title">
            </div>
            <div>
                <slot name="zidingyi1"></slot>
            </div>
            <div class="view-body"
                 v-if="item1.body">
                <div class="body-item"
                     v-for="(item2,index2) in item1.body"
                     :key="index2">
                    <div class="item-left subtitle"
                         v-if="item2.subtitle"
                         v-text="item2.subtitle">
                    </div>
                    <div class="item-left"
                         v-if="item2.title && !item2.subtitle"
                         v-text="item2.title"
                         :class="item2.head!==undefined&&item2.head===true?'item-link':''">
                    </div>
                    <div class="item-right"
                         v-if="item2.type==='text' && item2.name"
                         v-text="getContent(item2.name)">
                    </div>
                    <div class="item-right"
                         :class="'text-right'"
                         v-if="item2.type==='text-right' && item2.name"
                         v-text="getContent(item2.name)">
                    </div>
                    <div class="item-right"
                         :class="'item-tip'"
                         v-if="item2.type==='text-tip' && item2.name"
                         v-text="getContent(item2.name)">
                    </div>
                    <div class="item-right"
                         :class="'text-right item-tip'"
                         v-if="item2.type==='text-tip-right' && item2.name"
                         v-text="getContent(item2.name)">
                    </div>
                    <div class="item-right"
                         :class="'item-link'"
                         v-if="item2.type==='text-link' && item2.name"
                         v-text="getContent(item2.name)">
                    </div>
                    <div class="item-right"
                         v-if="item2.type==='text-sub' && item2.name">
                        <div class="text-nud" v-text="getContent(item2.name)"></div>
                        <div class="text-sub" v-text="getContent(item2.sub)"></div>
                    </div>
                    <div class="item-right"
                         v-if="item2.type==='select' && item2.name"
                         v-text="getSelectText(item2.name)">
                    </div>
                    <div class="item-right"
                         v-if="item2.type==='images' && item2.name">
                        <img class="item-img" :src="item3" v-for="(item3,index3) in getImageList(item2)"
                             :key="index3">
                    </div>
                    <div class="item-right"
                         v-if="item2.type==='download' && item2.name">
                        <div class="item-link"
                             v-for="(item3,index3) in getDownloadData(item2.name)"
                             v-text="item3[getLabelKey(item2)]"
                             :key="index3"
                             @click="downloadFile(item3,item2)">
                        </div>
                    </div>
                    <div class="item-right"
                         v-if="item2.type==='tables' && item2.columns && item2.name">
                        <div class="table-warp">
                            <table class="table"
                                   v-for="(item3, index3) in getTablesData(item2.name)" :key="index3">
                                <thead v-if="item2.hiddenHead ===undefined || item2.hiddenHead === false">
                                <tr>
                                    <th v-for="(item5, index5) in  item2.columns " :key="index5">
                                        {{item5.title}}
                                    </th>
                                </tr>
                                </thead>
                                <tbody class="text-nowrap">
                                <tr v-for="(item4, index4) in item3" :key="index4">
                                    <td v-for="(item5, index5) in  item2.columns " :key="index5">
                                        {{ item4[item5.field]}}
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="item-right"
                         v-if="item2.type==='table' && item2.columns && item2.name">
                        <div class="table-warp">
                            <table class="table">
                                <thead v-if="item2.hiddenHead ===undefined || item2.hiddenHead === false">
                                <tr>
                                    <th v-for="(item4, index4) in  item2.columns " :key="index4">
                                        {{item4.title}}
                                    </th>
                                </tr>
                                </thead>
                                <tbody class="text-nowrap">
                                <tr v-for="(item3, index3) in getTablesData(item2.name)" :key="index3">
                                    <td v-for="(item4, index4) in  item2.columns " :key="index4">
                                        {{ item3[item4.field]}}
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="item-right driver-line" style="border-bottom: 1px solid rgba(0,0,0,0.1)" v-if="item2.type==='driver'"></div>
                    <div class="item-right" style="font-size: 16px;font-weight: 800" v-if="item2.type==='subtitle'"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'i-detail-view',
        props: {
            value: {
                type: Object
            },
            attrs: {
                type: Array
            },
            opts: {
                type: Object
            }
        },
        data() {
            return {
                fileApi: process.env.VUE_APP_DOWNLOAD_API
            };
        },
        methods: {
            getValueKey(data) {
                const {valueKey} = data;
                return valueKey || 'value';
            },
            getLabelKey(data) {
                const {labelKey} = data;
                return labelKey || 'label';
            },
            getImageUrls(data, attr) {
                const result = [];
                if (data) {
                    if (typeof data === 'string') {
                        // 字符判断是否有逗号隔开
                        const split = data.split(',');
                        split.forEach(item => {
                            if (item) {
                                const url = this.getWholeUrl(item);
                                result.push(url);
                            }
                        });
                    } else if (Object.prototype.toString.call(data) === '[object Array]') {
                        data.forEach(item => {
                            if (item) {
                                if (item && typeof item === 'string') {
                                    const url = this.getWholeUrl(item);
                                    result.push(url);
                                } else if (typeof item === 'object') {
                                    const valueKey = this.getValueKey(attr);
                                    const value = item[valueKey];
                                    if (value && typeof value === 'string') {
                                        const url = this.getWholeUrl(value);
                                        result.push(url);
                                    }
                                }
                            }
                        });
                    } else if (typeof data === 'object') {
                        const valueKey = this.getValueKey(attr);
                        const value = data[valueKey];
                        if (value && typeof value === 'string') {
                            // 字符判断是否有逗号隔开
                            const split = value.split(',');
                            split.forEach(item => {
                                if (item) {
                                    const url = this.getWholeUrl(item);
                                    result.push(url);
                                }
                            });
                        }
                    }
                }
                return result;
            },
            downloadFile(item, att) {
                if (item && att) {
                    const url = item[this.getValueKey(att)];
                    const wholeUrl = this.getWholeUrl(url);
                    if (wholeUrl) window.open(wholeUrl, '_blank');
                }
            },
            getWholeUrl(url) {
                if (url) {
                    const fileApi = this.fileApi;
                    if (url) {
                        if (url.indexOf('http') === 0) {
                            return url;
                        } else if (fileApi) {
                            const newFileApi = fileApi.replace(/(\/*)$/g, '');
                            const newUrl = url.replace(/(^\/*)/g, '');
                            const wholeUrl = newFileApi + '/' + newUrl;
                            return wholeUrl;
                        }
                    }
                }
            }
        },
        computed: {
            getValue() {
                return this.value || [];
            },
            getAttrs() {
                return this.attrs || [];
            },
            getSelects() {
                const result = {};
                const attrs = this.getAttrs;
                if (attrs && attrs.length > 0) {
                    attrs.forEach(attr => {
                        const body = attr.body;
                        if (body && body.length > 0) {
                            body.forEach(item => {
                                const {type, name} = item || {};
                                if (name && type && type === 'select') {
                                    result[name] = {
                                        valueKey: this.getValueKey(item),
                                        labelKey: this.getLabelKey(item)
                                    };
                                }
                            });
                        }
                    });
                }
                return result;
            },
            getSelectOpts() {
                const result = {};
                const opts = this.opts || {};
                const attrs = this.getSelects;
                Object.keys(attrs).forEach(key => {
                    if (key) {
                        const attr = attrs[key];
                        const opt = opts[key];
                        if (attr && opt && opt.length > 0) {
                            const {valueKey, labelKey} = attr;
                            const map = {};
                            opt.forEach(item => {
                                map[item[valueKey] + ''] = item[labelKey];
                            });
                            result[key] = map;
                        }
                    }
                });
                return result;
            },
            getContent() {
                return (name) => {
                    const content = this.getValue[name];
                    return content || '';
                };
            },
            getSelectText() {
                return (name) => {
                    const opts = this.getSelectOpts[name];
                    const key = this.getValue[name];
                    if (key !== undefined && opts) {
                        return opts[key + ''] || '';
                    }
                    return '';
                };
            },
            getDownloadData() {
                return (name) => {
                    const downloads = this.getValue[name];
                    return downloads || [];
                };
            },
            getTablesData() {
                return (name) => {
                    const content = this.getValue[name];
                    return content || [];
                };
            },
            getImageList() {
                return (item) => {
                    const {name} = item;
                    const content = this.getValue[name];
                    return this.getImageUrls(content, item);
                };
            }
        }
    }
</script>

<style lang="scss" scoped>

    .i-detail-view {

        .view-area {
            margin-top: 8px;
            background-color: white;

            .view-head {
                height: 42px;
                line-height: 42px;
                font-size: 16px;
                padding: 0 16px;
                color: #101010;
                border: 1px solid rgba(236, 236, 236, 100);
                margin-bottom: 8px;
            }

            .view-body {
                padding-bottom: 8px;

                .body-item {
                    display: flex;
                    /*padding: 8px 20px 8px 44px;*/
                    padding: 8px 20px 8px 20px;

                    .item-left {
                        font-weight: bold;
                        font-size: 13px;
                        color: #101010;
                    }

                    .item-right {
                        font-size: 13px;
                        color: #101010;
                        flex: 1;
                    }

                    .item-img {
                        width: 96px;
                        height: 64px;
                        border: 1px solid #E8E8E8;
                        margin: 0 8px 8px 0;
                    }

                    .item-link {
                        color: #166DF1;
                    }
                    .subtitle{
                        height: 42px;
                        line-height: 42px;
                        font-size: 16px;
                        padding: 0 16px;
                        color: #101010;
                        border: 1px solid #ececec;
                        margin-bottom: 8px;
                        margin-left: -20px;
                        margin-right: -20px;
                        width: 100%;
                        flex: 1;
                    }

                    .text-sub {
                        margin-top: 4px;
                        font-size: 12px;
                        color: #717171;
                    }

                    .table-warp {
                        background-color: white;

                        .table {
                            background-color: #F7F8FA;
                            border: 1px solid #DEE2E6;
                            margin: 0;
                        }

                        .table + .table {
                            margin-top: 20px;
                        }

                        .table th, .table td {
                            padding: 6px 10px;
                            font-size: 12px;
                            border: 1px solid #DEE2E6;
                        }
                    }

                    .text-right {
                        text-align: right;
                    }

                    .item-tip {
                        color: #717171;
                        font-size: 12px;
                    }
                }
            }
        }

    }
</style>